import React from 'react';
import './CopyrightPage.css';

export const CopyrightContent = () => (
  <div className="copyright-content">
    <p>
      Except where otherwise noted, all content on this site is licensed under a{' '}
      <a
        href="https://creativecommons.org/licenses/by/3.0/"
        target="_blank"
        rel="noopener noreferrer"
        className="external"
      >
        Creative Commons Attribution License
      </a>
      .
    </p>
    <p>
      Except where otherwise noted, all software code on this site is licensed under a{' '}
      <a
        href="https://www.gnu.org/licenses/gpl.html"
        target="_blank"
        rel="noopener noreferrer"
        className="external"
      >
        GNU General Public License version 3
      </a>
      .
    </p>
    <p>
      Where applicable, other images, names and logos, are trademarks or registered trademarks of
      their respective owners.
    </p>
    <table className="no-border" style={{ margin: 'auto', padding: '5px' }}>
      <tbody>
        <tr>
          <td>
            <a
              href="https://creativecommons.org/licenses/by/3.0/"
              target="_blank"
              rel="license noopener noreferrer"
            >
              <img
                alt="Creative Commons License"
                style={{ borderWidth: 0 }}
                src="https://i.creativecommons.org/l/by/3.0/88x31.png"
              />
            </a>
          </td>
          <td>
            <a
              href="https://www.gnu.org/licenses/gpl.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://www.gnu.org/graphics/gplv3-88x31.png"
                alt="GPLv3"
                style={{ borderWidth: 0 }}
                width="88"
                height="31"
              />
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <p>
      <span className="update">Last updated: April 2, 2016</span>
    </p>
  </div>
);

export default CopyrightContent;
